import React from 'react'
import PropTypes from 'prop-types'
import useGlobalLoading from '@/hooks/useGlobalLoading'
import { isEmpty } from 'lodash'
import { getHeroData } from './functions'
import HeroContent from './components/HeroContent'
import { useMediaQuery } from '@uidotdev/usehooks'

HeroCustom.propTypes = {
  data: PropTypes.object,
}

export default function HeroCustom({ data }) {
  const isMobile = useMediaQuery('only screen and (max-width: 768px)')
  const isTablet = useMediaQuery('only screen and (min-width : 768px) and (max-width : 1280px)')
  const isDesktop = useMediaQuery('only screen and (min-width: 1280px)')

  const { loading } = useGlobalLoading()

  const { containerStyles, backgroundStyle, rows } = getHeroData({
    data,
    isMobile,
    isTablet,
    isDesktop,
  })

  if (isEmpty(data)) return null

  return (
    <section className={containerStyles} style={backgroundStyle}>
      <HeroContent rows={rows} loading={loading} />
    </section>
  )
}
